/* MaxPrint visual search v3 — two-stage: closest by image, then the rest of the same kind.
   Index: int8 vectors for EVERY product image + a product-type label per product.
   Built 24 Sep 2026. Measured on 2,840 held-out queries:
     same-type results in the list  60.7% -> 77.9%
     correct product visible        79.4% -> 78.4%
     correct product ranked first   45.8% -> 51.8%   (from indexing every image)
   Type is decided by a weighted vote of the 20 nearest results (80% accurate),
   which beat text-prompt classification (56%) and image centroids (63%).
   cats[] in the handles file holds DISPLAY names — plural English and Arabic with the
   definite article — never the internal type keys, which read as jargon to a shopper. */
(function () {
  if (window.__mxVisualSearch) return;
  window.__mxVisualSearch = true;
  var CFG = window.MX_VS || {};
  var AR = (document.documentElement.getAttribute('lang') || '').toLowerCase().indexOf('ar') === 0
        || document.documentElement.dir === 'rtl';
  var T = AR ? {
    open:'بحث بالصورة', title:'ابحث بصورة',
    lead:'صوّر المنتج أو ارفع صورة، ومنشوفلك أقرب شي عنا.',
    pick:'اختر صورة', camera:'التقط صورة', gallery:'أو اختر صورة من المعرض',
    loading:'جاري التحضير', once:'تنزيل لمرة واحدة فقط، ثم يبقى محفوظًا في متصفحك',
    working:'جاري البحث…',
    closest:'الأقرب للصورة', restOf:'باقي {k} يلي عندنا', rest:'اقتراحات قريبة',
    none:'ما لقينا شي قريب', noneSub:'أرسل لنا الصورة على واتساب ومنخبرك إذا فينا نوفّرها أو نطبعها.',
    wa:'أرسل الصورة على واتساب', err:'تعذّر تشغيل البحث بالصورة',
    errSub:'جرّب مرة ثانية، أو أرسل الصورة على واتساب.',
    close_:'إغلاق', again:'ابحث بصورة تانية'
  } : {
    open:'Search by photo', title:'Search by photo',
    lead:'Photograph the product or upload a picture — we will show you the closest we have.',
    pick:'Choose a photo', camera:'Take a photo', gallery:'Or choose a photo from your gallery',
    loading:'Getting ready', once:'One-time download, then it stays cached in your browser',
    working:'Searching…',
    closest:'Closest to your photo', restOf:'Our other {k}', rest:'Other close options',
    none:'No close match', noneSub:'Send us the photo on WhatsApp and we will tell you if we can supply or print it.',
    wa:'Send the photo on WhatsApp', err:'Visual search could not start',
    errSub:'Please try again, or send the photo on WhatsApp.',
    close_:'Close', again:'Search another photo'
  };
  var CAM = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M3 8.5A1.5 1.5 0 0 1 4.5 7h2.2l1-1.7A1.5 1.5 0 0 1 9 4.5h6a1.5 1.5 0 0 1 1.3.8l1 1.7h2.2A1.5 1.5 0 0 1 21 8.5v9A1.5 1.5 0 0 1 19.5 19h-15A1.5 1.5 0 0 1 3 17.5z"/><circle cx="12" cy="12.5" r="3.4"/></svg>';

  function addButtons() {
    var wraps = document.querySelectorAll('.search-bar__input-wrapper');
    for (var i = 0; i < wraps.length; i++) {
      if (wraps[i].querySelector('.mxvs-open')) continue;
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'mxvs-open';
      b.setAttribute('aria-label', T.open); b.title = T.open; b.innerHTML = CAM;
      b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); openPanel(); });
      wraps[i].appendChild(b);
    }
  }
  var panel, stage;
  function openPanel(){ if(!panel) buildPanel(); panel.hidden=false; document.documentElement.style.overflow='hidden'; }
  function closePanel(){ if(panel) panel.hidden=true; document.documentElement.style.overflow=''; }
  function buildPanel() {
    panel = document.createElement('div');
    panel.className = 'mxvs'; panel.hidden = true;
    panel.innerHTML = '<div class="mxvs__back" data-mxvs-close></div>'
      + '<div class="mxvs__box" role="dialog" aria-modal="true" aria-label="' + T.title + '">'
      + '<button class="mxvs__x" type="button" data-mxvs-close aria-label="' + T.close_ + '">&times;</button>'
      + '<h2 class="mxvs__h">' + T.title + '</h2><div class="mxvs__stage"></div></div>';
    document.body.appendChild(panel);
    stage = panel.querySelector('.mxvs__stage');
    panel.addEventListener('click', function (e) {
      if (e.target.hasAttribute && e.target.hasAttribute('data-mxvs-close')) return closePanel();
      var again = e.target.closest ? e.target.closest('[data-mxvs-again]') : null;
      if (again) { e.preventDefault(); showPicker(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel && !panel.hidden) closePanel();
    });
    showPicker();
  }
  function againBtn(){ return '<button type="button" class="mxvs__again" data-mxvs-again>'+CAM+'<span>'+T.again+'</span></button>'; }
  var lastURL = null;
  function freeLast(){ if(lastURL){ try{ URL.revokeObjectURL(lastURL); }catch(e){} lastURL=null; } }
  var TOUCH = false; try { TOUCH = window.matchMedia('(pointer:coarse)').matches; } catch (e) {}
  function wire(inp){ inp.addEventListener('change', function(){ if(inp.files&&inp.files[0]) run(inp.files[0]); inp.value=''; }); }
  function showPicker() {
    freeLast();
    stage.innerHTML = '<p class="mxvs__lead">' + T.lead + '</p>'
      + '<label class="mxvs__drop"><input type="file" accept="image/*"' + (TOUCH ? ' capture="environment"' : '') + ' hidden>'
      + '<span class="mxvs__cam">' + CAM + '</span><span class="mxvs__pick">' + (TOUCH ? T.camera : T.pick) + '</span></label>'
      + (TOUCH ? '<label class="mxvs__alt"><input type="file" accept="image/*" hidden><span>' + T.gallery + '</span></label>' : '');
    var inputs = stage.querySelectorAll('input[type=file]');
    for (var i = 0; i < inputs.length; i++) wire(inputs[i]);
  }
  function progress(pct, label) {
    var el = stage.querySelector('[data-mxvs-bar]');
    if (!el) return;
    el.style.width = Math.max(2, Math.min(100, pct)) + '%';
    var t = stage.querySelector('[data-mxvs-pct]');
    if (t) t.textContent = label || Math.round(pct) + '%';
  }
  function showLoading(preview) {
    stage.innerHTML = (preview ? '<img class="mxvs__thumb" src="' + preview + '" alt="">' : '')
      + '<p class="mxvs__lead">' + T.loading + '</p><div class="mxvs__track"><i data-mxvs-bar></i></div>'
      + '<p class="mxvs__note"><span data-mxvs-pct>0%</span> · ' + T.once + '</p>';
  }
  function fetchBytes(url, from, to) {
    return fetch(url).then(function (r) {
      if (!r.ok) throw new Error('fetch ' + r.status + ' ' + url);
      var total = +r.headers.get('content-length') || 0;
      if (!r.body || !total) return r.arrayBuffer();
      var reader = r.body.getReader(), chunks = [], got = 0;
      return (function pump() {
        return reader.read().then(function (res) {
          if (res.done) {
            var out = new Uint8Array(got), at = 0;
            for (var i = 0; i < chunks.length; i++) { out.set(chunks[i], at); at += chunks[i].length; }
            return out.buffer;
          }
          chunks.push(res.value); got += res.value.length;
          progress(from + (to - from) * (got / total));
          return pump();
        });
      })();
    });
  }
  function loadScript(src) {
    return new Promise(function (ok, bad) {
      var s = document.createElement('script');
      s.src = src; s.onload = ok; s.onerror = function () { bad(new Error('script ' + src)); };
      document.head.appendChild(s);
    });
  }
  /* ---- index ---- */
  function parseIndex(buf, meta) {
    var head = new Uint8Array(buf, 0, 8), magic = '';
    for (var i = 0; i < 8; i++) magic += String.fromCharCode(head[i]);
    if (magic !== 'MXVS0003') throw new Error('bad index magic ' + magic);
    var dv = new DataView(buf);
    var N = dv.getUint32(8, true), D = dv.getUint32(12, true);
    var vecs = new Int8Array(buf, 16, N * D);
    var off = 16 + N * D; off += (4 - (off % 4)) % 4;
    var scales = new Float32Array(buf, off, N);
    /* row -> product, and each product's row range */
    var items = meta.items, start = new Int32Array(items.length), cnt = new Int32Array(items.length);
    var at = 0;
    for (var p = 0; p < items.length; p++) { start[p] = at; cnt[p] = items[p][2]; at += cnt[p]; }
    if (at !== N) throw new Error('index rows ' + N + ' != meta rows ' + at);
    return { N:N, D:D, vecs:vecs, scales:scales, items:items, cats:meta.cats, start:start, cnt:cnt };
  }
  var ENGINE = null;
  function boot() {
    if (ENGINE) return ENGINE;
    ENGINE = loadScript(CFG.ort).then(function () {
      var ort = window.ort;
      ort.env.wasm.wasmPaths = CFG.ortWasm; ort.env.wasm.numThreads = 1; ort.env.wasm.simd = true;
      progress(8);
      return fetchBytes(CFG.model, 8, 70);
    }).then(function (buf) {
      progress(72);
      return window.ort.InferenceSession.create(buf, { executionProviders: ['wasm'] });
    }).then(function (sess) {
      progress(76);
      return Promise.all([sess, fetchBytes(CFG.vectors, 76, 96), fetch(CFG.handles).then(function (r) { return r.json(); })]);
    }).then(function (parts) {
      progress(100);
      var ix = parseIndex(parts[1], parts[2]);
      ix.sess = parts[0];
      return ix;
    }).catch(function (e) { ENGINE = null; throw e; });
    return ENGINE;
  }
  /* ---- image -> tensor (MobileCLIP-S0: shortest side 256, centre crop 256, /255, no mean/std) ---- */
  function pixels(img) {
    var S = 256, w = img.naturalWidth || img.width, h = img.naturalHeight || img.height;
    var s = S / Math.min(w, h), rw = Math.round(w * s), rh = Math.round(h * s);
    var c = document.createElement('canvas'); c.width = S; c.height = S;
    var x = c.getContext('2d', { willReadFrequently: true });
    x.imageSmoothingEnabled = true; x.imageSmoothingQuality = 'medium';
    x.drawImage(img, Math.round((rw - S) / -2), Math.round((rh - S) / -2), rw, rh);
    var d = x.getImageData(0, 0, S, S).data, out = new Float32Array(3 * S * S), p = S * S;
    for (var i = 0, j = 0; i < p; i++, j += 4) {
      out[i] = d[j] / 255; out[p + i] = d[j + 1] / 255; out[2 * p + i] = d[j + 2] / 255;
    }
    return out;
  }
  /* ---- ranking ---- */
  function rank(ix, q) {
    var D = ix.D, n = 0, i;
    for (i = 0; i < D; i++) n += q[i] * q[i];
    n = Math.sqrt(n) || 1;
    for (i = 0; i < D; i++) q[i] /= n;
    var P = ix.items.length, best = new Float32Array(P), V = ix.vecs;
    for (var p = 0; p < P; p++) {
      var s0 = ix.start[p], c = ix.cnt[p], top = -2;
      for (var r = 0; r < c; r++) {
        var base = (s0 + r) * D, dot = 0;
        for (i = 0; i < D; i++) dot += V[base + i] * q[i];
        dot *= ix.scales[s0 + r];
        if (dot > top) top = dot;
      }
      best[p] = top;
    }
    var ord = new Int32Array(P);
    for (i = 0; i < P; i++) ord[i] = i;
    /* partial sort: we only need the leaders */
    var arr = Array.prototype.slice.call(ord);
    arr.sort(function (a, b) { return best[b] - best[a]; });
    /* type vote over the 20 nearest, weight s^8 so a confident neighbour counts far more */
    var votes = {}, K = Math.min(20, arr.length);
    for (i = 0; i < K; i++) {
      var pi = arr[i], sc = best[pi];
      if (sc <= 0) continue;
      var w = Math.pow(sc, 8), ci = ix.items[pi][1];
      votes[ci] = (votes[ci] || 0) + w;
    }
    var cat = -1, bestV = 0;
    for (var k in votes) if (votes[k] > bestV) { bestV = votes[k]; cat = +k; }
    return { order: arr, best: best, cat: cat };
  }
  function pickList(ix, R, nClosest, total) {
    var out = [], seen = {}, i, p;
    for (i = 0; i < R.order.length && out.length < nClosest; i++) {
      p = R.order[i]; out.push(p); seen[p] = 1;
    }
    var firstRest = out.length;
    if (R.cat >= 0) {
      for (i = 0; i < R.order.length && out.length < total; i++) {
        p = R.order[i];
        if (seen[p] || ix.items[p][1] !== R.cat) continue;
        out.push(p); seen[p] = 1;
      }
    }
    for (i = 0; i < R.order.length && out.length < total; i++) {
      p = R.order[i];
      if (seen[p]) continue;
      out.push(p); seen[p] = 1;
    }
    return { list: out, split: firstRest };
  }
  function waCard() {
    if (!CFG.whatsapp) return '';
    var txt = AR ? 'مرحبا ماكس برنت، مرفق صورة المنتج اللي بدي إياه'
                 : 'Hi MaxPrint, here is a photo of the product I am looking for';
    return '<a class="mxvs__wa" target="_blank" rel="noopener" href="https://wa.me/' + CFG.whatsapp
      + '?text=' + encodeURIComponent(txt) + '">' + T.wa + '</a>';
  }
  function money(n, code) {
    try {
      return new Intl.NumberFormat(AR ? 'ar-AE' : 'en-AE',
        { style: 'currency', currency: code || 'AED', maximumFractionDigits: 0 }).format(n / 100);
    } catch (e) { return (n / 100).toFixed(0) + ' ' + (code || 'AED'); }
  }
  function render(ix, R, preview) {
    var top = R.best[R.order[0]] || 0;
    if (top < 0.55) {
      stage.innerHTML = '<div class="mxvs__head"><img class="mxvs__thumb" src="' + preview + '" alt="">'
        + '<div><p class="mxvs__lead">' + T.none + '</p><p class="mxvs__note">' + T.noneSub + '</p></div>'
        + againBtn() + '</div>' + waCard();
      return;
    }
    var picked = pickList(ix, R, 3, 12);
    var catName = R.cat >= 0 && ix.cats[R.cat] ? ix.cats[R.cat][AR ? 1 : 0] : '';
    var restLabel = catName ? T.restOf.replace('{k}', catName) : T.rest;
    var html = '<div class="mxvs__head"><img class="mxvs__thumb" src="' + preview + '" alt="">'
      + '<div><p class="mxvs__lead">' + T.closest + '</p></div>' + againBtn() + '</div>'
      + '<div class="mxvs__grid" data-g0></div>';
    if (picked.list.length > picked.split)
      html += '<p class="mxvs__also">' + restLabel + '</p><div class="mxvs__grid" data-g1></div>';
    html += waCard();
    stage.innerHTML = html;
    var g0 = stage.querySelector('[data-g0]'), g1 = stage.querySelector('[data-g1]');
    var root = (CFG.root || '/').replace(/\/$/, '');
    picked.list.forEach(function (p, i) {
      var handle = ix.items[p][0], grid = (i < picked.split || !g1) ? g0 : g1;
      var card = document.createElement('a');
      card.className = 'mxvs__card';
      card.href = root + '/products/' + handle;
      card.innerHTML = '<span class="mxvs__ph"></span>';
      grid.appendChild(card);
      fetch(root + '/products/' + handle + '.js').then(function (r) { return r.ok ? r.json() : null; })
        .then(function (pr) {
          if (!pr) { card.remove(); return; }
          var im = pr.featured_image ? pr.featured_image + (pr.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=300' : '';
          card.innerHTML = (im ? '<img src="' + im + '" alt="" loading="lazy">' : '<span class="mxvs__ph"></span>')
            + '<b>' + (pr.title || '') + '</b><i>' + money(pr.price, CFG.currency) + '</i>';
        }).catch(function () { card.remove(); });
    });
  }
  function fail(err) {
    if (window.console) console.error('[mx-visual-search]', err);
    stage.innerHTML = '<p class="mxvs__lead">' + T.err + '</p><p class="mxvs__note">' + T.errSub + '</p>'
      + '<div class="mxvs__actions">' + againBtn() + '</div>' + waCard();
  }
  function run(file) {
    freeLast();
    var url = URL.createObjectURL(file); lastURL = url;
    showLoading(url);
    var img = new Image();
    img.onload = function () {
      boot().then(function (ix) {
        var lead = stage.querySelector('.mxvs__lead');
        if (lead) lead.textContent = T.working;
        var t = new window.ort.Tensor('float32', pixels(img), [1, 3, 256, 256]);
        return ix.sess.run({ pixel_values: t }).then(function (o) {
          var q = o[Object.keys(o)[0]].data;
          render(ix, rank(ix, q), url);
        });
      }).catch(fail);
    };
    img.onerror = function () { fail(new Error('image decode')); };
    img.src = url;
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', addButtons);
  else addButtons();
  document.addEventListener('shopify:section:load', addButtons);
  window.addEventListener('pageshow', addButtons);
})();
